export default "__VITE_ASSET__dJVjqUse__"